// extracted by mini-css-extract-plugin
export default {"buttonContianer":"TemplateRenameModal__buttonContianer___ShGvn"};